import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchUserDetails = createAsyncThunk(
    "queue/fetchUserDetails",
    async (_, thunkAPI) => {
      try {
        const response = await axios.get('/zdsgfd');
        // console.log(response,'userslice');
        
        return response.data;
      } catch (error) {
        return thunkAPI.rejectWithValue(
          error.response?.data || "Failed to fetch queue details"
        );
      }
    }
  );

const userQueueSlice = createSlice({
  name: "userqueue",
  initialState: {
    userData: [],
    loadingUserData: false, // <-- This is the correct property
    errorUsers: null,
  }
  ,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      // Fetch Queue List
      .addCase(fetchUserDetails.pending, (state) => {
        state.loadingUserData = true;
        state.errorUsers = null;
      })
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        state.loadingUserData = false; // ✅ Correct property
        state.userData = action.payload;
      })
      
      .addCase(fetchUserDetails.rejected, (state, action) => {
        state.loadingUserData = false;
        state.errorUsers = action.payload;
      })
  },
});

export default userQueueSlice.reducer;